import React, { FC } from 'react';
import {
  CapacityDownWrapper,
  CapacityLeftWrapper,
  CapacityRightWrapper,
  QualityWrapper,
  ServiceWrapper,
  SubTitle,
  Text,
  Title,
  Wrapper,
} from './styles';

type Props = {
  wrapperRef?: any;
};
const ServiceSection: FC<Props> = ({ wrapperRef }) => {
  return (
    <Wrapper ref={wrapperRef}>
      <ServiceWrapper>
        <Title>
          O QUE <b>FAZEMOS</b>
        </Title>
        <Text center>
          Projetos que traduzem desejos, proporcionam bem-estar e conforto,
          realizando formas e sonhos.
        </Text>
      </ServiceWrapper>
      <QualityWrapper>
        <CapacityLeftWrapper>
          <SubTitle>PROJETOS ARQUITETÔNICOS</SubTitle>
          <Text>
            Desenvolvemos projetos arquitetônicos residenciais completos, desde
            a análise do terreno até a concepção do projeto final. Levamos em
            conta a orientação solar, topografia, legislação local e
            preferências do cliente para criar casas únicas, contemporâneas e
            cheias de significado.
          </Text>
        </CapacityLeftWrapper>
        <CapacityDownWrapper>
          <SubTitle>PROJETO DE INTERIORES</SubTitle>
          <Text>
            Criamos projetos de interiores residenciais personalizados, com
            curadoria de acabamentos, mobiliário e iluminação. Acompanhamos
            todas as etapas da implantação, garantindo ambientes confortáveis,
            funcionais e com identidade — espaços que acolhem e refletem o
            estilo dos moradores.
          </Text>
        </CapacityDownWrapper>
        <CapacityRightWrapper>
          <SubTitle>GESTÃO DE PROJETOS</SubTitle>
          <Text>
            Temos uma equipe especializada em gestão de obras, que acompanha
            todo o processo com organização, comprometimento e atenção aos
            detalhes. Monitoramos prazos, orçamentos e execução para assegurar
            que tudo ocorra conforme o previsto em projeto.
          </Text>
        </CapacityRightWrapper>
      </QualityWrapper>
      <QualityWrapper isSmallMarginTop>
        <CapacityLeftWrapper>
          <SubTitle>PROJETOS ARQUITETÔNICOS</SubTitle>
          <Text>
            Desenvolvemos projetos arquitetônicos residenciais completos, desde
            a análise do terreno até a concepção do projeto final. Levamos em
            conta a orientação solar, topografia, legislação local e
            preferências do cliente para criar casas únicas, contemporâneas e
            cheias de significado.
          </Text>
        </CapacityLeftWrapper>
      </QualityWrapper>
    </Wrapper>
  );
};

export default ServiceSection;
